/** Push must wait until a P50 exists for the current MC-on scenario. */
export function shouldBlockPushP50({ mcEnabled, mcPending, mcProjection }) {
  return Boolean(mcEnabled && (mcPending || !mcProjection));
}
